import { collection, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

export async function getHighOddsAIGames() {
  const colRef = collection(db, 'highOddsAI');
  const querySnap = await getDocs(colRef);

  const list = [];
  querySnap.forEach((doc) => {
    list.push({ id: doc.id, ...doc.data() });
  });

  return list;
}
